import { getCurrentFinancialDeckEntity } from "@/models/financialDecks";
import { Badge, Group } from "@mantine/core";
import { useAtomValue } from "jotai";
import { PiBankBold } from "react-icons/pi";

export const LoanTypeIndicator = () => {
  const { data: model } = useAtomValue(
    getCurrentFinancialDeckEntity().getObserveEntityRecordAtom(),
  );

  return (
    <Badge
      radius={"xs"}
      size="lg"
      bg="infomatic.1"
      c="infomatic.8"
      color="infomatic"
      bd={"1px solid var(--mantine-color-infomatic-2)"}
      h={28}
      px={"xs"}
      tt={"none"}
    >
      <Group gap={"xs"}>
        <PiBankBold size={16} />

        {model?.loanType === "sba7a" && <>SBA 7(a) Loan</>}
        {model?.loanType === "conventional" && <>Conventional Loan</>}
      </Group>
    </Badge>
  );
};
